import { render, staticRenderFns } from "./json-editor.vue?vue&type=template&id=e138721a&scoped=true&"
import script from "./json-editor.vue?vue&type=script&lang=js&"
export * from "./json-editor.vue?vue&type=script&lang=js&"
import style0 from "./json-editor.vue?vue&type=style&index=0&id=e138721a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e138721a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e138721a')) {
      api.createRecord('e138721a', component.options)
    } else {
      api.reload('e138721a', component.options)
    }
    module.hot.accept("./json-editor.vue?vue&type=template&id=e138721a&scoped=true&", function () {
      api.rerender('e138721a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/json-editor.vue"
export default component.exports